/**
 * Parse a numeric display value.
 * Cell and stat strings from the API may already include a space (or nbsp)
 * as a thousand separator ("2 400.00"). `parseFloat` stops at that space
 * and keeps only the leading digits.
 * @param {unknown} value
 * @returns {number}
 */
export const parseDisplayNumber = (value) => {
  if (typeof value === 'number') return value;
  if (typeof value !== 'string') return Number.NaN;

  const compact = value.replace(/[\s\u00a0\u202f]/g, '');
  if (!compact) return Number.NaN;

  const lastComma = compact.lastIndexOf(',');
  const lastDot = compact.lastIndexOf('.');
  let normalized = compact;

  if (lastComma !== -1 && lastDot !== -1) {
    if (lastComma > lastDot) {
      normalized = compact.replace(/\./g, '').replace(',', '.');
    } else {
      normalized = compact.replace(/,/g, '');
    }
  } else if (lastComma !== -1) {
    normalized = compact.replace(',', '.');
  }

  return Number.parseFloat(normalized);
};
